import { Component, OnInit, QueryList, ViewChild, ViewChildren } from '@angular/core';
import { MatPaginator, PageEvent } from '@angular/material/paginator';
import { MatSort, Sort, SortDirection } from '@angular/material/sort';
import { MatTableDataSource } from '@angular/material/table';
import { map } from 'rxjs/operators';
import { FilterTypeEnum } from '../../_common/enums/filter.enum';
import { PrinterMechanismStatusResponse, PrintersStatusListResponse, PrintersStatusModel } from './printers-status.model';
import { PrintersStatusService } from './printers-status.service';
import { MatDialog } from '@angular/material/dialog';
import { Router } from '@angular/router';
import { PrinterMechanismStatusEnum } from './printers-status.enum';
import { faHeartbeat, faCheck, faTimes } from '@fortawesome/free-solid-svg-icons';
import { PAGE_SIZE_DEFAULT, PAGE_SIZE_OPTIONS } from 'src/app/_common/constants';
import { TranslateService } from '@ngx-translate/core';
import { BrandService } from 'src/app/administration/brands/brand.service';
import { TableFiltersComponent } from 'src/app/_common/components/filters/table-filters/table-filters.component';
import { ToastrService } from 'ngx-toastr';
import { Subscription } from 'rxjs';

@Component({
  selector: 'app-printers-status',
  templateUrl: './printers-status.component.html',
  styleUrls: ['./printers-status.component.scss']
})
export class PrintersStatusComponent implements OnInit {

  faCheckPrinterMechanism = faHeartbeat;
  faCheck = faCheck;
  faTimes = faTimes;

  printerStatuses!: MatTableDataSource<PrintersStatusModel>;

  pageEvent!: PageEvent;
  
  pageIndex: number = 0;
  pageSize: number = PAGE_SIZE_DEFAULT;
  pageSizeOptions: number[] = PAGE_SIZE_OPTIONS;

  sortDirection: SortDirection = 'asc';
  sortColumn: string = 'shopNumber';
  
  items: PrintersStatusModel[] = [];
  totalRows!: number;
  columns: any[] = [    
    {
      name: 'shopNumber',
      filter: {
        type: FilterTypeEnum.Text,
        name: 'filter-shopNumber'
      }
    },
    {
      name: 'shopName',
      filter: {
        type: FilterTypeEnum.Text,
        name: 'filter-shopName'
      }
    },
    {
      name: 'printerIp',
      filter: {
        type: FilterTypeEnum.None,
        name: 'filter-printerIp'
      }
    },
    {
      name: 'printerName',
      filter: {
        type: FilterTypeEnum.Text,
        name: 'filter-printerName'
      }
    },
    {
      name: 'printerUniqueNumber',
      filter: {
        type: FilterTypeEnum.Text,
        name: 'filter-printerUniqueNumber'
      }
    },
    {
      name: 'printerEvidenceNumber',
      filter: {
        type: FilterTypeEnum.Text,
        name: 'filter-printerEvidenceNumber'
      }
    },
    {
      name: 'receiptCount',
      filter: {
        type: FilterTypeEnum.None,
        name: 'filter-receiptCount'
      }
    },
    {
      name: 'dailyReportCount',
      filter: {
        type: FilterTypeEnum.None,
        name: 'filter-dailyReportCount'
      }
    },
    {
      name: 'dataFrom',
      filter: {
        type: FilterTypeEnum.None,
        name: 'filter-dataFrom'
      }
    },
    {
      name: 'dataTo',
      filter: {
        type: FilterTypeEnum.None,
        name: 'filter-dataTo'
      }
    },
    {
      name: 'lastCommunicationDate',
      filter: {
        type: FilterTypeEnum.None,
        name: 'filter-lastCommunicationDate'
      }
    },
    {
      name: 'daysSinceLastCommunication',
      filter: {
        type: FilterTypeEnum.None,
        name: 'filter-daysSinceLastCommunication'
      }
    },
    {
      name: 'isActive',
      filter: {
        type: FilterTypeEnum.Select,
        name: 'filter-isActive',
        options: [
          { name: '', value: null },
          { name: 'common.yes', value: true },
          { name: 'common.no', value: false }
        ]
      }
    },
    {
      name: 'printerMechanismStatus',
      filter: {
        type: FilterTypeEnum.None,
        name: 'filter-printerMechanismStatus'
      }
    },
    {
      name: 'actions',
      filter: {
        type: FilterTypeEnum.None,
        name: 'filter-actions'
      }
    }
  ];

  displayedColumns: any[] = this.columns.map(x => x.name);
  filterColumns: any[] = this.columns.map(x => x.filter).map(x => x.name);
  filter: any = {};
  filterTypes: typeof FilterTypeEnum = FilterTypeEnum;
  printerMechanismStatusEnum: typeof PrinterMechanismStatusEnum = PrinterMechanismStatusEnum;
  brands = [];

  downloadSubscription: Subscription;

  @ViewChild(MatPaginator) paginator!: MatPaginator;
  @ViewChild(MatSort) sort!: MatSort;
  @ViewChildren('filterRefs') filterRefs!: QueryList<TableFiltersComponent>;

  constructor(private printersStatusService: PrintersStatusService,
    private translateService: TranslateService,
    public dialog: MatDialog,
    public router: Router,
    public brandService: BrandService,
    private toastr: ToastrService) { 
      this.downloadSubscription = this.printersStatusService.downloadPrintersStatus$.subscribe((type) => {
        this.download(type);
      });
    }

  ngOnInit(): void {
    if(this.brandService.brandList.model.length > 1){
      this.columns.unshift({
        name: 'brands',
        filter: {
          type: FilterTypeEnum.MultipleSelect,
          name: 'filter-brands'
        }
      })
      this.displayedColumns = this.columns.map(x => x.name);
      this.filterColumns = this.columns.map(x => x.filter).map(x => x.name);
    }
    this.getBrandList();
    this.loadData();
  }

  onPaginateChange(event: PageEvent) {
    this.pageIndex = event.pageIndex;
    this.pageSize = event.pageSize;
    this.loadData();
  }

  onSortData(event: Sort) {
    this.sortDirection = event.direction;
    this.sortColumn = event.active;
    this.pageIndex = 0;
    this.loadData();
  }

  loadData() {
    this.printersStatusService
      .getPrintersStatuses(this.pageIndex, this.pageSize, this.sortColumn, this.sortDirection, this.filter)
      .pipe(map((res: PrintersStatusListResponse) => {
        this.items = res.model;
        this.totalRows = res.totalRows;
      }))
      .subscribe();
  }

  filterData(filter: any) {
    this.filter = filter;
    this.pageIndex = 0;
    this.loadData();
  }

  checkPrinterMachanismStatus(printer: PrintersStatusModel){
    var socket = printer.printerIp;
    if(printer.printerPort) {
      socket += ':' + printer.printerPort;
    }
    this.printersStatusService.checkPrinterMachanismStatus(socket)
    .pipe(map((res: PrinterMechanismStatusResponse) => {
      printer.printerMechanismStatus = res.model;
    }))
    .subscribe();
  }

  checkAllPrinterMachanismStatus(){
    this.items.forEach(function(item){
      this.checkPrinterMachanismStatus(item);
    })
  }

  getRectangleColor(value: number, isPrinterStatus: boolean): string {
    let green = 0;
    let red = 10;

    if (isPrinterStatus) {
      red = 3
      if (value > 0) {
        value = red - 1;
      }
    }

    if (value > red) {
      value = red;
    }

    const hue = (1 - (value - green) / (red - green)) * 120;
    return `hsl(${hue}, 100%, 26%)`;
  }

  transformPrinterStatus(text: string): string {
    if (!text) {
      return '';
    }

    var initials = text.split(' ').map(word => word.charAt(0).toUpperCase()).join('');
    
    if (text === this.translateService.instant('reports.printers-status.no-error')){
      initials = "OK";
    }

    return initials;
  }

  getBrandList() {
    this.brandService.getBrandList().then(() => {
      const brandList = this.brandService.brandList.model;

      if (brandList.length){
        this.brands = brandList.map(item => ({
          value: item.id,
          name: `<div class="brand"><img class="logo" src="data:image/png;base64,${item.logo}"/><span>${item.name}</span></div>`
        }));

        const brandColumn = this.columns.find(column => column.name === "brands");

        if(!brandColumn){
          return;
        }

        brandColumn.filter.options = [...this.brands];        
        const brandFilter = this.filterRefs.find(f => f.column?.name === "brands");
        
        const allValues = this.brands.map(b => b.value);
        brandFilter.multipleSelectFormControl.setValue(allValues);
        this.filter["brands"] = allValues;
      }
    })
  }

  download(type: string) {
    if (type == 'xlsx') {
      this.printersStatusService.downloadXlsx(this.filter).subscribe(
        response => {
          this.getDownload(type, response);
        });
    }
  }

  private getDownload(type: string, response: any) {
    if (response.status == 204) {
      this.toastr.error(`${this.translateService.instant('common.error.downloading-file-failed').replace('{type}', type.toUpperCase())}`);
      return;
    }

    let mimeType;
    switch (type) {
      case 'xlsx':
        mimeType = 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet';
        break;
    }

    const blob = new Blob([response.body], { type: mimeType });
    const url = window.URL.createObjectURL(blob);
    const anchor = document.createElement('a');
    anchor.href = url;
    anchor.download = response.filename;
    anchor.click();
    window.URL.revokeObjectURL(url);
  }
}
